import { useEffect } from 'react';

const usePreventInspect = () => {
    useEffect(() => {
        const handleContextMenu = (e) => {
            e.preventDefault(); // Disable right-click
        };

        const handleKeyDown = (e) => {
            // Disable F12, Ctrl+Shift+I/J/C/U
            if (
                e.keyCode === 123 || // F12
                (e.ctrlKey && e.shiftKey && (e.keyCode === 73 || e.keyCode === 74 || e.keyCode === 67)) || // Ctrl+Shift+I/J/C
                (e.ctrlKey && e.keyCode === 85) // Ctrl+U
            ) {
                e.preventDefault();
            }
        };

        document.addEventListener('contextmenu', handleContextMenu);
        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('contextmenu', handleContextMenu);
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);
};

export default usePreventInspect;
